import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { AttributeQueryKeys } from './attributeQueryKeys';

export const useDeleteAttributeTypeMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, string>({
        mutationFn: (id) => apiClient.attributeTypes.deleteAttributeType(id),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: AttributeQueryKeys.all,
                });
            }
        },
    });
};
